"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventHandler = void 0;
const react_1 = require("react");
function useEventHandler(channel, event, handler) {
    const handlerFun = (0, react_1.useRef)(handler);
    handlerFun.current = handler;
    (0, react_1.useEffect)(() => {
        if (channel === null) {
            return;
        }
        const ref = channel.on(event, (message) => {
            handlerFun.current(message);
        });
        // eslint-disable-next-line consistent-return
        return () => {
            channel.off(event, ref);
        };
    }, [channel, event]);
}
exports.useEventHandler = useEventHandler;
